import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import Loader from 'src/shared/components/loader/Loader';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import useAuthService from 'src/shared/hooks/useAuthService';
import loginStorageService from '../services/login-storage-service';

const Signin = () => {
    const { isAuthenticated, hasGivenTncConsent } = useAuthService();
    const navigate = useAppNavigation();
    const [searchParams] = useSearchParams();
    const redirectTo = searchParams.get('redirectTo');
    const shopify = searchParams.get('shopify');

    useEffect(() => {
        if (redirectTo) {
            loginStorageService.setRedirectPath(redirectTo);
        }
        if (shopify) {
            loginStorageService.setRedirectPath('shopify');
        }

        if (!shopify && isAuthenticated && hasGivenTncConsent) {
            navigate.toCustomers();
        } else if (!isAuthenticated) {
            navigate.toLogin();
        }
    }, [isAuthenticated, shopify]);

    return <Loader />;
};
export default Signin;
